import { useTranslation } from 'react-i18next'

import { ListRequestParams, UnloadingType } from 'modules/domain/types'
import { FC } from 'react'
import { ASelectFilter } from 'views/components/Analytics'

type Props = {
  listRequestParams: ListRequestParams
  updateFilterState: (filterObj: Record<string, any>) => void
}

export const UnloadingTypeFilter: FC<Props> = ({ listRequestParams, updateFilterState }) => {
  const { t } = useTranslation('logisticsKR')

  const statusOptions = Object.keys(UnloadingType).map((unloading_type) => ({
    value: unloading_type,
    label: t(`directions.${unloading_type}`),
  }))

  return (
    <ASelectFilter
      placeholder={t('cars.filters.unloading_type')}
      options={statusOptions}
      value={listRequestParams.filter.unloading_type || []}
      mode="multiple"
      onChange={(unloading_type) => updateFilterState({ unloading_type })}
      showSearch={false}
      id="unloadingTypeFilter"
    />
  )
}
